

























import {Vue, Component} from 'vue-property-decorator';
import {ToasterConfig} from "@/types/ToasterConfig";

@Component
export default class Toaster extends Vue {

  public arrow: any = {
    up: require('@/assets/arrow-up-fill.svg'),
    down: require('@/assets/arrow-down-fill.svg'),
  };
  public arrowDirection: any = this.arrow.down;
  public seeMore: boolean = false;

  mounted() {
    if (this.config.visibleOnNextPage) {
      this.$store.commit('visibleOnThisPage');
    } else if (this.config.message !== "") {
      this.$store.commit('removeToaster');
    }
  }

  get config(): ToasterConfig {
    return this.$store.state.toasterModule.toaster;
  }

  close() {
    this.$store.commit('removeToaster');
  }

  toggleSeeMore() {
    if (this.config.isVisible) {
      this.seeMore = !this.seeMore;
      this.seeMore ? (this.arrowDirection = this.arrow.up) : (this.arrowDirection = this.arrow.down);
    }
  }

}

